import { render, staticRenderFns } from "./BlueTitle.vue?vue&type=template&id=6584cca8&scoped=true&"
import script from "./BlueTitle.vue?vue&type=script&lang=js&"
export * from "./BlueTitle.vue?vue&type=script&lang=js&"
import style0 from "./BlueTitle.vue?vue&type=style&index=0&id=6584cca8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6584cca8",
  null
  
)

export default component.exports